import React, {useContext, useEffect, useMemo, useState} from 'react';
import {useTranslation} from "react-i18next";
import Auxiliary from "../../hoc/Auxiliary";
import {Modal} from "react-bootstrap";
import Alert from "../UI/Alerts/Alert";
import SelectWrapper from "../Utils/Input/SelectWrapper";
import DatePicker from "react-datepicker";
import fr from 'date-fns/locale/fr-CA';
import axios from "../../axios-defaults";
import Spinner from "../UI/Spinner";
import userContext from "../../context/user-context";
import formatDate from "../Utils/Date/formatDate";
import DateFormated from "../Utils/Date/Date";
import {Link} from "react-router-dom";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {fireGTMOrderingEvent} from "../Utils/GTM/GTMHelper";


const OrderPopup = (props) => {
    const {user} = useContext(userContext);
    const {t, i18n} = useTranslation();
    const [filling, setFilling] = useState(true);
    const [deliveryDate, setDeliveryDate] = useState();
    const [loading, setLoading] = useState(false);
	const [loadingSubAccount, setLoadingSubAccount] = useState(false);
    const [onlineOrderDefaults, setOnlineOrderDefaults] = useState();
    const [deliveryPriority, setDeliveryPriority] = useState();
    const [deliveryOrigin, setdeliveryOrigin] = useState();
    const [message, setMessage] = useState();
    const [confirmation, setConfirmation] = useState(false);
    const [formValuesObj, setFormValuesObj] = useState();
	const [subaccount, setSubaccount] = useState();

	const getSubAccount = async (code) => {
		setLoadingSubAccount(true);
		return await axios.get("/subAccounts", {
			params: { subAccountCode: code, }
		}).then(response => {
			setLoadingSubAccount(false);
			if (response.data.succeeded){
				return response.data.data
			}
			return [];
		}).catch(error => {
			setLoadingSubAccount(false);
			return [];
		});
	}

	useMemo(async () => {
		if (!props.subAccount && props.currentTank && props.currentTank.subAccountCode) {
			setSubaccount(await getSubAccount(props.currentTank.subAccountCode));
		} else if (props.subAccount) {
			setSubaccount(props.subAccount);
		}
	}, [props.subAccount]);

    let isadmin = false;
    if (
        typeof user?.infos?.is_admin !== undefined
        && user.infos.is_admin === true
        && (
            (
                user.infos.personnification_account_id !== undefined
                && user.infos.personnification_account_id !== 0
            )
        )
    ) {
        isadmin = true;
    }
    let modalContent = null;
    let modalForm = null;
    let modalActions = null;


    useEffect(async () => {
		if(subaccount){
			setLoading(true);
			await getOnlineOrderDefaults();
			if (isadmin) {
				await getDeliveryOrigin();
				await getDeliveryPriority();
			}
			setLoading(false);
		}
    }, [isadmin, subaccount])

    const handleSubmit = (event) => {
        event.preventDefault();
        let formValues = null;
        if (isadmin) {
            let dateConverted = formatDate(new Date(event.target.elements.date.value));
            formValues = {
                accountCode: subaccount.accountCode,
                subAccountCode: subaccount.subAccountCode,
                lines: [
                    {
                        lineNumber: 0,
                        productCode: props.currentTank.product.code,
                        tankNumber: props.currentTank.tankId,
                        fixedPrice: event.target.elements.price.value != "" ? parseInt(event.target.elements.price.value) : 0,
                        requestedQuantity: !filling ? parseInt(event.target.elements.qty.value) : 1,
                        isRequestedFull: filling ? true : false
                    }
                ],
                purchaseOrderNumber: event.target.elements.ordernumber.value,
                deliveryNote: event.target.elements.note.value,
                orderInstruction: onlineOrderDefaults.orderInstruction,
                customerNote: onlineOrderDefaults.customerNote,
                deliveryDate: dateConverted, //"2022-02-14T14:11:08.048Z",
                organizationUnitCode: event.target.elements.treadted.value,
                orderPriority: event.target.elements.priority.value,
                orderOrigin: event.target.elements.origin.value,
                deliveryMode: "C",
                orderedByEmail: user.infos.email
            }
        } else {
            formValues = {
                accountCode: subaccount.accountCode,
                subAccountCode: subaccount.subAccountCode,
                lines: [
                    {
                        lineNumber: 0,
                        productCode: props.currentTank.product.code,
                        tankNumber: props.currentTank.tankId,
                        fixedPrice: 0,
                        requestedQuantity: 1,
                        isRequestedFull: true
                    }
                ],
                purchaseOrderNumber: event.target.elements.ordernumber.value,
                deliveryNote: event.target.elements.note.value,
                orderInstruction: onlineOrderDefaults.orderInstruction,
                customerNote: onlineOrderDefaults.customerNote,
                deliveryDate: onlineOrderDefaults.deliveryDate, //"2022-02-14T14:11:08.048Z",
                organizationUnitCode: onlineOrderDefaults.organizationUnitCode,
                orderPriority: onlineOrderDefaults.orderPriority.code,
                orderOrigin: onlineOrderDefaults.orderOrigin.code,
                deliveryMode: "C",
                orderedByEmail: user.infos.email
            }
        }

        setFormValuesObj(formValues)
        setLoading(true);
        axios.post(`/subAccounts/postOnlineOrder`, formValues)
            .then(response => {
                if (response.data.succeeded) {
                    setConfirmation(true);
					fireGTMOrderingEvent('2_succes',{product : props.currentTank.product.descriptionFr});
                    setMessageConfirmation(response.data.data.orderId);
                }
                setLoading(false);
            }).catch(error => {
            console.log('[OrderPopup.js] : Communications ajax error in sendOrder()', error.message)
			fireGTMOrderingEvent('9_echoue',{product : props.currentTank.product.descriptionFr});
            setLoading(false);
        });
    }

    const getOnlineOrderDefaults = async () => {
        await axios.get(`/subAccounts/onlineOrderDefaults?accountCode=${subaccount.accountCode}&subAccountCode=${subaccount.subAccountCode}&deliveryMode=C&tankNumber=${props.currentTank.tankId}`)
            .then(response => {
                if (response.data.succeeded) {
                    setOnlineOrderDefaults(response.data.data);
                }
            }).catch(error => {
                console.log('[OrderPopup.js] : Communications ajax error in getOnlineOrderDefaults()', error.message)
            });
    }
    const getDeliveryPriority = async () => {
        await axios.get(`/references/deliveryPriority`)
            .then(response => {
                if (response.data.succeeded) {
                    let priority
                        = response.data.data.map(function (item, index) {
                        return <option key={index} value={item.deliveryPriority.code}>{
                            i18n.language === "fr"
                                ? item.deliveryPriority.descriptionFr
                                : item.deliveryPriority.descriptionEn
                        }</option>;
                    })
                    setDeliveryPriority(priority);
                }
            }).catch(error => {
                console.log('[OrderPopup.js] : Communications ajax error in getDeliveryPriority()', error.message)
            });
    }
    const getDeliveryOrigin = async () => {
        await axios.get(`/references/deliveryOrigin`)
            .then(response => {
                if (response.data.succeeded) {
                    let origins
                        = response.data.data.map(function (item, index) {
                        return <option key={index} value={item.deliveryOrigin.code}>{
                            i18n.language === "fr"
                                ? item.deliveryOrigin.descriptionFr
                                : item.deliveryOrigin.descriptionEn
                        }</option>;
                    })
                    setdeliveryOrigin(origins);
                }
            }).catch(error => {
                console.log('[OrderPopup.js] : Communications ajax error in getDeliveryOrigin()', error.message)
            });
    }

    const askFilling = () => {
        if (isadmin) {
            setFilling(!filling);
        }
    };

    const setMessageConfirmation = (orderId) => {
        let html = <div className="row row--rmline">
            <div className="message message--success message--condensed">
                <div className="message__icon">
                    <i className="fas fa-check-circle"></i>
                </div>
                <div className="message__content">
                    <div>
                        <span>{t('popuporder.success_message.line1')}</span> <strong
                        className="p--c-black">{t('popuporder.success_message.line2')}</strong>
                        <span
                            className="p--c-black">{' '}#{orderId}</span>
                        {/*<span className="p--c-black">{t('popuporder.success_message.line3')}</span>*/}
                    </div>
                </div>
            </div>
        </div>
        setMessage(html);
        $('.modal-body').animate({scrollTop: 0});
    }

    if (props.currentTank && !loading && !loadingSubAccount && onlineOrderDefaults) {

        modalContent = <Auxiliary>
            <div className="row">
                <div className="col-6">
                    <p>  {t('popuporder.tank')}<br/>
                        <strong>{props.currentTank.tankName}</strong></p>
                    <p>
						{ (subaccount && subaccount.address) ?
							(
								<>
									{(subaccount.address.addressLine1)
										? (<span>{subaccount.address.addressLine1}<br/></span>)
										: ''
									}
									{(subaccount.address.addressLine2)
											? (<span>{subaccount.address.addressLine2}<br/></span>)
											: ''
									}
									{(subaccount.address.city)
										? (<span>{subaccount.address.city}</span>)
										: ''
									}
									{(subaccount.address.stateOrProvinceCode)
										? (<span>,&nbsp;{subaccount.address.stateOrProvinceCode}<br/></span>)
										: ''
									}
									{ (subaccount.address.postalCode) ? subaccount.address.postalCode : '' }
								</>
							)
						: '' }
                    </p>
                    <p>
                        <strong>
                            {onlineOrderDefaults.deliveryDelayMessage !== null ?
                                i18n.language === "fr"
                                    ? onlineOrderDefaults.deliveryDelayMessage.descriptionFr
                                    : onlineOrderDefaults.deliveryDelayMessage.descriptionEn : ''}

                        </strong>
                    </p>
                </div>
                <div className="col-6">
                    <p>
                        {t('popuporder.product')}<br/>
                        <span className="price--smaller">
                        {i18n.language === "fr"
                            ? props.currentTank.product.descriptionFr
                            : props.currentTank.product.descriptionEn
                        }
                            </span>
                    </p>
                    <p>{t('popuporder.capacity')}<br/>
                        <span className="price--small">
                        {props.currentTank.capacity.formattedUnitValue}
                        </span>
                    </p>
                </div>
                {!confirmation && onlineOrderDefaults.deliveryFeeMessage !== null ? <div className="col-12 mb-2 mt-2">
                    <Alert type="danger" item={{
                        type: 'danger',
                        link: '',
                        additionalClasses: 'message--condensed',
                        customIcon: 'fas fa-exclamation-triangle',
                        text: i18n.language === "fr"
                            ? onlineOrderDefaults.deliveryFeeMessage.descriptionFr
                            : onlineOrderDefaults.deliveryFeeMessage.descriptionEn

                    }}/>
                </div> : <div className="col-12 mb-2 mt-2"></div>}

                {(isadmin) ?
                    !confirmation ? <div className="col-12 mt-3">
                        <div className="row row--rmline">
                            <div className="col-sm-6">
                                <strong>{t('popuporder.customernote')}</strong><br/>
                                <span className="p--c-gray">{onlineOrderDefaults.customerNote}</span>
                            </div>
                            <div className="col-sm-6">
                                <strong>{t('popuporder.orderinsc')}</strong><br/>
                                <span className="p--c-gray">{onlineOrderDefaults.orderInstruction}</span>
                            </div>
                        </div>
                    </div> : ''
                    : ''}
            </div>
        </Auxiliary>;
        modalForm = <Auxiliary>
            <form onSubmit={handleSubmit} id="orderform">
                <div className="row row--rmline">
                    <div className="col-sm-6">
                        <label htmlFor={'ordernumber'} className="input-field">{t("popuporder.ordernumber")}<br/>
                            <input className="_full" type={'text'} name={'ordernumber'}
                                   defaultValue={onlineOrderDefaults.purchaseOrderNumber}
                                   maxLength="16"
                                   placeholder=""/></label>
                    </div>
                    <div className="col-sm-6">
                        <div className="d-flex">
                            <label htmlFor={'qty'} className="input-field">{t("popuporder.quantity")}
                                {(isadmin) ? <React.Fragment><br/><input className="_full" type={'number'} name={'qty'}
                                                                         defaultValue={''}
                                                                         placeholder="" disabled={filling}
                                                                         readOnly={filling}/></React.Fragment> :
                                    ''}
                            </label>
                            {(isadmin) ?
                                <label htmlFor={'price'} className="input-field ml-3">{t("popuporder.price")}<br/>
                                    <input className="_full" type={'number'} name={'price'}
                                           defaultValue={''}
                                           placeholder=""/></label>
                                :
                                ''
                            }
                        </div>

                        <label className="checkbox-field checkbox-field--gray">
                            <input
                                type="checkbox"
                                name={'filling'}
                                checked={filling}
                                onChange={askFilling}
                            />
                            <span></span>
                            {t("popuporder.filling")}
                            {(!isadmin) ? <OverlayTrigger placement='bottom'
                                                          overlay={<Tooltip id="tooltip-right" >
                                                              {t("popuporder.onlyfill")}
                                                          </Tooltip>}>
                                <div className="btn-info-tooltip btn-info-tooltip--inline"><i
                                    className="far fa-info-circle"></i></div>
                            </OverlayTrigger> : ''}
                        </label>
                    </div>
                </div>

                <div className="row row--rmline">
                    <div className="col-12">
                        <label htmlFor={'note'} className="input-field">{t("popuporder.shippingnote")}<br/>
                            <textarea name={'note'} className="_full" placeholder={t("popuporder.notecontent")}
                                      defaultValue={onlineOrderDefaults.deliveryNote}/>
                        </label>
                    </div>

                    {(isadmin) ?
                        <Auxiliary>
                            <div className="col-sm-6">
                                <label className="input-field">
                                    <strong>{t('popuporder.deliverydate')}</strong><br/>
                                    <div className="form-datepicker">
                                        <DatePicker
                                            autoComplete="off"
                                            id="deliverydate"
                                            name="date"
                                            locale={(() => {
                                                if (i18n.language == "fr") {
                                                    return (fr)
                                                }
                                            })()}
                                            onChange={(date) => setDeliveryDate(date)}
                                            selected={deliveryDate ? deliveryDate : new Date(onlineOrderDefaults.deliveryDate)}
                                            dateFormat="dd MMMM yyyy"
                                            className="form-control _full"
                                        />
                                        <i className="icon far fa-calendar-alt"></i>
                                    </div>
                                </label>
                                <br/>
                                <label className="input-field">
                                    <strong className="">{t('popuporder.priority')}</strong><br/>
                                    <SelectWrapper>
                                        <select id="priority" name="priority" defaultValue={onlineOrderDefaults.orderPriority.code}>
                                            {deliveryPriority}
                                        </select>
                                    </SelectWrapper>
                                </label>
                            </div>
                            <div className="col-sm-6">
                                <label className="input-field">
                                    <strong className="">{t('popuporder.treadtedby')}</strong><br/>
                                    <SelectWrapper>
                                        <select id="treatedby" name="treadted" defaultValue="">
                                            <option
                                                value={onlineOrderDefaults.organizationUnitCode}>{onlineOrderDefaults.organizationUnitCode}</option>
                                        </select>
                                    </SelectWrapper>
                                </label>
                                <br/>
                                <label className="input-field">
                                    <strong className="">{t('popuporder.origin')}</strong><br/>
                                    <SelectWrapper>
                                        <select id="origin" name="origin" defaultValue={onlineOrderDefaults.orderOrigin.code}>
                                            {deliveryOrigin}
                                        </select>
                                    </SelectWrapper>
                                </label>

                            </div>
                        </Auxiliary>
                        :
                        ''
                    }
                </div>


            </form>
        </Auxiliary>;

        modalActions = <div className="d-flex flex-wrap w-100 ">
            <div className="col-5 d-flex justify-content-start">
                <button className="btn btn--outline btn--outline--black btn--fs-12"
                         onClick={()=>props.onHideNReload("canceled")}>{t("popuporder.cancel")}</button>
            </div>
            <div className="col-7 d-flex justify-content-end">
                <button className="btn btn--raised btn--raised--red btn--fs-12" form="orderform"
                        type="submit">{t("popuporder.confirm")}&nbsp;&nbsp;<i
                    className="fas fa-angle-right"></i></button>
            </div>
        </div>;

    } else {
        modalContent = <Spinner/>;
    }
    if (confirmation && !loading && onlineOrderDefaults) {

        modalForm = <Auxiliary>
            <div className="row--addline"></div>
            <div className="row mt-3">
                <div className="col-sm-6">
                    <strong>{t("popuporder.ordernumber")}</strong><br/>
                    <span className="p--c-gray">{formValuesObj.purchaseOrderNumber}</span>
                </div>
                <div className="col-sm-6">
                    <strong>{t("popuporder.quantity")}</strong><br/>
                    <span className="p--c-gray">
                {isadmin ?
                    formValuesObj.lines[0].isRequestedFull ?
                        t("popuporder.full") :
                        formValuesObj.lines[0].requestedQuantity :
                    t("popuporder.full")
                }
            </span>
                </div>
                <div className="col-sm-6 mt-3">
                    <strong>{t("popuporder.shippingnote_short")}</strong><br/>
                    <span className="p--c-gray">
                {formValuesObj.deliveryNote}
            </span>
                </div>
                {isadmin ? <Auxiliary>
                    <div className="col-sm-6 mt-3">
                        <strong>{t("popuporder.deliverydate")}</strong><br/>
                        <span className="p--c-gray">
                        <DateFormated date={formValuesObj.deliveryDate} withTime={false}/>
            </span>
                    </div>
                    <div className="col-sm-6 mt-3">
                        <strong>{t("popuporder.treadtedby")}</strong><br/>
                        <span className="p--c-gray">
                {formValuesObj.organizationUnitCode}
            </span>
                    </div>
                    <div className="col-sm-6 mt-3">
                        <strong>{t("popuporder.priority")}</strong><br/>
                        <span className="p--c-gray">
                            {deliveryPriority.map(item => (item.props.value === formValuesObj.orderPriority ? item.props.children : ''))}

            </span>
                    </div>
                    <div className="col-sm-6 mt-3">
                        <strong>{t("popuporder.origin")}</strong><br/>
                        <span className="p--c-gray">
                            {deliveryOrigin.map(item => (item.props.value === formValuesObj.orderOrigin ? item.props.children : ''))}

            </span>
                    </div>

                </Auxiliary> : ''}


            </div>
            <div className="row row--rmline mt-3 w-100">
                <div className="col-sm-9 d-flex justify-content-start mb-3">
                    <p>{t("popuporder.notification")}<br/>
                        <Link to={'/profile#notifications'}
                              className="link link--red">{t("popuporder.notificationedit")}</Link></p>
                </div>
            </div>
        </Auxiliary>;


        modalActions = <div className="row row--rmline w-100">
            <div className="col-sm-9 "></div>
            <div className="col-sm-3 d-flex justify-content-end">
                <button className="btn btn--raised btn--raised--red btn--fs-12 w-100"
                        onClick={()=>props.onHideNReload('completed')}>{t("popuporder.close")}</button>
            </div>
        </div>
    }

    return (


        <Modal show={props.show}
               onHide={props.onHide}
               dialogClassName="ultimate-modal"
               keyboard={true}
               backdrop="static"
               animation={false}
        >
            <Modal.Header>
                <h3 className="headline headline--c-white headline--block headline--margin--0 text-uppercase headline--weight--extra-bold headline--fs-22">
                    {!confirmation ? t('popuporder.title') : t('popuporder.titleconfirm')}
                </h3>
            </Modal.Header>
            <Modal.Body style={{maxHeight: "70vh"}}>
                {message}
                {modalContent}
                {modalForm}
            </Modal.Body>
            <div className="modal-actions d-flex justify-content-between">
                {modalActions}
            </div>
        </Modal>
    );
}

export default OrderPopup;
